/**
 * Trigger: tr_expenses_soft_delete
 * Purpose: Update account balances when an expense is soft deleted or restored
 * Table: expenses
 * Event: UPDATE OF is_deleted
 */
export const TR_EXPENSES_SOFT_DELETE = `
CREATE TRIGGER tr_expenses_soft_delete
UPDATE OF is_deleted ON expenses
WHEN new.is_deleted <> old.is_deleted
BEGIN
  -- Update account balances (very fast with indexes)
  UPDATE account_balances
  SET expenses_amount = CASE
    WHEN new.is_deleted = 0 THEN expenses_amount + old.amount
    ELSE expenses_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id;

  -- Update daily balances (very fast with indexes)
  UPDATE account_daily_balances
  SET expenses_amount = CASE
    WHEN new.is_deleted = 0 THEN expenses_amount + old.amount
    ELSE expenses_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.expense_date;

  -- Delete only THIS specific daily balance record if all amounts are zero
  -- (instead of scanning entire table)
  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.expense_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  -- Delete only THIS specific activity date record if no balances exist
  -- (instead of scanning entire table with NOT EXISTS)
  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND activity_date = old.expense_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_daily_balances.account_id = old.account_id
        AND account_daily_balances.balance_date = old.expense_date
      LIMIT 1
    );
END;
`;
